import { Box, Typography } from '@mui/material';
import { LOADER_ICON } from 'src/common/constants/brand';

export default function LoaderOverlay() {
  return (
    <Box
      width="100vw"
      height="100vh"
      position="fixed"
      zIndex={(theme) => theme.zIndex.modal + 1}
      display="flex"
      flexDirection="column"
      alignItems={'center'}
      justifyContent={'center'}
      top={0}
      left={0}
      right={0}
      bottom={0}
      bgcolor={'#fff'}
    >
      <img src={LOADER_ICON.Src} alt="loader-icon" width={LOADER_ICON.Width} />
      <Typography mt={1}>Cargando...</Typography>
    </Box>
  );
}
